





























import Vue from 'vue'
import PresetRow from '@/components/PresetRow.vue'
import { devlst_vmode_t, dev_property_t, THUMB_SIZE_VW, thumb_size_t } from '@/store/modules/pref'
import { Extender, Preset } from '@/types/api'
import { ppp } from '@/utils'
import { IDevice, IVW } from '@/types/model'
import easyapi from '@/easyapi'
import { reqMan } from '@/singleton'

export default Vue.extend({
  data (): {
    THUMB_SIZE_VW: thumb_size_t[]
  } {
    return {
      THUMB_SIZE_VW
    }
  },
  components: {
    PresetRow,
  },
  computed: {
    presets (): Preset[] { return this.$state.device.presetList },
  },
  methods: {
    clickLeftIcon () { this.$router.go(-1) },
    create () {
      this.$router.push({ name: 'preset_create' })
    }
  },
  watch: {
    //
  },
  mounted () {
    reqMan.ensureWsAvailable(() => {
      easyapi.fetchPresetList()
    })
  }
})
